import { getLenis } from "./base";

document.addEventListener("DOMContentLoaded", () => {
  const pageTopBtn = document.querySelector(".c-btn--pagetop");

  if (!pageTopBtn) return;

  pageTopBtn.addEventListener("click", (e) => {
    e.preventDefault();

    const lenis = getLenis();

    if (lenis) {
      lenis.scrollTo(0, {
        duration: 1,
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  });
});
